/** @jsxImportSource @emotion/react */
import { useTranslation } from 'react-i18next'
import { I18N_REPORT_NS } from '../../../i18n'
import { Space, Grid, Typography, Card } from 'antd'
import { css } from '@emotion/css'
import { paragraphStyle } from '../../../theme'
import { classes } from '../../style'
import { renderReportPeriod } from '../index'
import { getPeriodStart } from '../../../utils/period'
import { HtmlText } from '../../../components/display/htmlText'
import dayjs from 'dayjs'
const { useBreakpoint } = Grid

const vertSpaceProps = { direction: 'vertical', style: { width: '100%' } }

// Fixed summary height so quarter cards in a row stay aligned; scrolls when the
// text is longer. 20 lines of 12px text at line-height 1.5 → 20 * 1.5em = 30em.
const SUMMARY_FONT_SIZE = 12
const SUMMARY_LINE_HEIGHT = 1.5
const SUMMARY_VISIBLE_LINES = 20

const PeriodSyndicatorSummaryCard = ({ report, text }) => {
	const { xs } = useBreakpoint()

	if (!text) return null

	return (
		<Card
			className={css({
				backgroundColor: xs ? 'white' : 'var(--violet-bg)',
				marginTop: 14,
				'.ant-card-body': {
					flexDirection: 'column',
					display: 'flex'
				}
			})}
		>
			<Typography.Text
				strong
				className={css({ fontSize: 14, lineHeight: 1, paddingBottom: 8, color: 'var(--violet-dark)' })}
			>
				{getPeriodStart(report) && `${renderReportPeriod(report)}:`}
			</Typography.Text>
			<div
				className={css({
					fontSize: SUMMARY_FONT_SIZE,
					lineHeight: SUMMARY_LINE_HEIGHT,
					height: `${SUMMARY_LINE_HEIGHT * SUMMARY_VISIBLE_LINES}em`,
					overflowY: 'auto',
					whiteSpace: 'pre-line',
					'& p': { margin: 0 }
				})}
			>
				<HtmlText value={text} />
			</div>
		</Card>
	)
}

export const SyndicatorSummary = ({ reports }) => {
	const { t } = useTranslation([I18N_REPORT_NS])
	return (
		<Space {...vertSpaceProps} size={0}>
			<Space {...vertSpaceProps} size={0}>
				<Typography.Text strong className={css({ fontSize: 14, lineHeight: 1 })}>
					{t('syndicator_summary_title')}
				</Typography.Text>
				<Typography.Text className={css({ ...paragraphStyle, fontSize: 10, lineHeight: 1 })}>
					{t('syndicator_summary_notes')}
				</Typography.Text>
			</Space>

			<Space css={classes.columns}>
				{reports
					?.sort((a, b) => (dayjs(getPeriodStart(a)).diff(dayjs(getPeriodStart(b))) > 0 ? -1 : 1))
					?.map(report => (
						<PeriodSyndicatorSummaryCard
							key={report.id ?? report.quarter}
							report={report}
							text={report.syndicator_summary}
						/>
					))}
			</Space>
		</Space>
	)
}
